import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CartService } from 'src/app/services/cart.service';
import { CommonService } from 'src/app/services/common-services/common.service';
import { ShopCommonService } from 'src/app/services/shop-service/shop.service';
import { environment } from 'src/environments/environment';
import { cloneDeep, first, isEmpty, last } from 'lodash';
import { TemplateType, TemplateTypeLabel } from 'src/app/shared/constants/constants';
import { getCustomerToken } from 'src/app/shared/utils';
import { LandingService } from '../services/landing.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {
  currentSlide = 0;
  autoSlideInterval: any;
  baseUrl = environment.BASE_URL;
  shopBaseUrl = environment.SHOP_BASE_URL;
  productList:any [] = [];
  indirectApi!: string;
  addedCatNames: Set<any> = new Set();
  addedSubCatNames: Set<any> = new Set();
  addedRFQType = '';
  companyId = localStorage.getItem('customercompanyId');
  cartMap: Map<number, any> = new Map();
  responseArray: any[] = [];
  popularCategoryList:any [] = [];
  sliderList:any[] = [];
  isSummitShow:boolean = false;
  sliderUrl:string = 'https://shop.unibuild.ai/';
  private routeDataSubscription !:Subscription;
  event:string= '';
  constructor(
    private commonServices: CommonService,
    private customerService: ShopCommonService,
    public dialog: MatDialog,
    private cartService: CartService,
    private toastr: ToastrService,
    private router: Router,
   // private route: Router,
    private route: ActivatedRoute,
    private landingService: LandingService,
  ) {}
  ngOnInit() {
    this.routeDataSubscription = this.route.data.subscribe((data) => {
      this.sliderList = data['slider'].images;
      this.productList = data['product'].data;
      this.popularCategoryList = data['category'];
    });
    this.startAutoSlide();
    this.cartService.getAllCategories();
    this.cartService.getAllProductIdCategoryId();
    //this.summitPopupOpen()
    this.route.queryParams.subscribe((params) => {
      this.event = params['name'];
      if (this.event) {
        localStorage.setItem('event', this.event);
      }
    });
  }
  summitPopupOpen(){
    if(this.commonServices.summitCounter < 1){
      document.body.classList.add('summitPopupOpen');
      this.isSummitShow = true;
      setTimeout(() => {
        this.closeSummitPopup();
      }, 15000);
    }
    
  }
  closeSummitPopup(){
    document.body.classList.remove('summitPopupOpen');
    this.isSummitShow = false;
    this.commonServices.summitCounter++;
  }
  openFlyerLink(){
    let flyerLink = 'https://share.hsforms.com/1XBz0HDlBRXanWgTvU4XfMQqaxbi'
    window.open(flyerLink, '_blank');
  }
  ngOnDestroy() {
    clearInterval(this.autoSlideInterval);
  }
  getSliderImage(){
    this.landingService.requestDataSlider().subscribe({
      next: (res:any) =>{
        this.sliderList = res.images;
      }
    })
  }
  getProductList(){
    //let apiUrl = `${this.shopBaseUrl}v1/products?limit=8&page=1`;
    this.landingService.requestDataPopularProduct().subscribe((data) => {
      this.productList = data?.data;
    });
  }
  redirectProductDetail(productId: number, catId?: number, catName?: any) {
    this.router.navigate([`/product/${productId}`]);
  }
  addToCart(product: any) {
    this.addedCatNames = new Set();
    this.addedSubCatNames = new Set();
    this.addedRFQType = '';
    let rfqType = '';
    if (this.cartService.productIdCategoryId.has(product.id)) {
      let categoryIds: any = this.cartService.productIdCategoryId.get(product.id);
      categoryIds = new Set(categoryIds);
      this.getCategorySubCategory(categoryIds, false);
    }
    if (this.addedRFQType == 'Capital Equipments') {
      rfqType = TemplateType.CapEx;
    } else if (this.addedRFQType == 'Indirect MRO') {
      rfqType = TemplateType.InDirectMRO;
    } else {
      rfqType = TemplateType.Others;
    }
    const cmsCatName = first(Array.from(this.addedCatNames));
    const cmsSubCatName = last(Array.from(this.addedSubCatNames));
    let payLoad = {
      productId: product.id,
      productName: product.name,
      quantity: 1,
      date: new Date().toISOString(),
      cmsCatName: cmsCatName,
      cmsSubCatName: cmsSubCatName,
      imageUrl: product.base_image.original_image_url,
      rfqTemplate: rfqType,
      tags: this.getSelectedItemHierarchy(product.name),
    };
    this.companyId = localStorage.getItem('customercompanyId');
    // let customerToken = localStorage.getItem('customerToken');
    let customerToken = getCustomerToken();
    if (!customerToken) {
      this.addtoStorageCart(product.id, payLoad);
    } else {
      Object.assign(payLoad, {
        companyId: this.companyId,
      });
      let apiUrl = `${this.baseUrl}rfq/cart/addCart`;
      this.commonServices.postDatawithoutHeaders(apiUrl, payLoad).subscribe((data) => {
        this.toastr.success('Product added to cart', '', {
          positionClass: 'toast-bottom-right',
        });
        this.cartService.getCartItems();
      });
    }
    // this.commonServices.getData(this.indirectApi).subscribe((data) => {
    //   this.products = data?.data;
    //   this.originalProductsList = data?.data;
    // });
  }

  addtoStorageCart(id: number, product: any): void {
    let cartLocalData: any = localStorage.getItem('cartData');
    if(cartLocalData){
      let dataItem = JSON.parse(cartLocalData);
      let cartValue = Object.values(dataItem);
      cartValue.forEach((product: any) => {
        if (this.cartMap.has(product.productId)) {
          let productItem = this.cartMap.get(product.productId);
          if(productItem.productId == id){
            productItem.quantity = productItem.quantity + 1;
          }
        } else {
          this.cartMap.set(product.productId, product);
        }
      });
    }
    if (this.cartMap.has(id) && !cartLocalData) {
      let cartItem = this.cartMap.get(id);
      cartItem.quantity = cartItem.quantity + 1;
    } else {
      this.cartMap.set(id, product);
    }
    const obj = Object.fromEntries(this.cartMap.entries());
    localStorage.setItem('cartData', JSON.stringify(obj));
    this.toastr.success('Product added to cart', '', {
      positionClass: 'toast-bottom-right',
    });
    this.responseArray = Object.values(obj);
    let responseObject = {
      response: this.responseArray,
    };
    this.cartService.cartUpdates.next(responseObject);
    this.cartMap.clear();
  }
  getCategorySubCategory(categoryIds: number[], fromChild: boolean) {
    categoryIds?.forEach((categoryId: number) => {
      this.cartService.categories?.forEach((data: any) => {
        if (data.category_id == categoryId) {
          if (!fromChild) {
            this.addedSubCatNames.add(data.name);
            // } else if (fromChild) {
            //   this.addedCatNames.add(data.name);
          }
          if (data?.parent_id && data?.parent_id != 1) {
            this.getCategorySubCategory([data.parent_id], true);
          }
          if (data.parent_id == 1) {
            this.addedRFQType = data.name;
            this.addedCatNames.add(data.name);
          }
        }
      });
    });
  }
  getSelectedItemHierarchy(itemName: string, joinWith: string = '|') {
    const categories = new Set([...this.addedCatNames, ...this.addedSubCatNames]);
    return [...categories].join(joinWith);
  }
  getCategoryProduct(categoryId: number) {
    //this.activeCategoryId = categoryId;
    this.router.navigate(['/products'], {
      queryParams: {
        catId: categoryId,
      },
    });
  }
  getPopularCategory(){
    this.landingService.requestDataPopularCategory().subscribe({
      next:(responseList:any) => {
        this.popularCategoryList = responseList
      }
    })
  }
  getRelatedProducts(categoryId:number){
    this.router.navigate(['/products'], {
      queryParams: {
        catId: categoryId,
      },
    });
  }
  startAutoSlide() {
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000); // Change slide every 3 seconds
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide === this.sliderList.length - 1) ? 0 : this.currentSlide + 1;
  }

  goToSlide(slideIndex: number) {
    this.currentSlide = slideIndex;
    clearInterval(this.autoSlideInterval);
    this.startAutoSlide(); // Restart auto-slide after manual navigation
  }

  slickCapabilitesConfig = {
    slidesToShow: 4,        // Number of slides visible at once on desktop
    slidesToScroll: 1,      // Number of slides to scroll per swipe on desktop
    autoplay: true,         // Enable autoplay
    autoplaySpeed: 3000,    // Autoplay speed (milliseconds)
    dots: false,            // Show dots for navigation
    infinite: true,         // Enable infinite scroll
    responsive: [
      {
        breakpoint: 768,    // For mobile devices (adjust this value as needed)
        settings: {
          slidesToShow: 1,  // Show 1 slide at a time on mobile
          slidesToScroll: 1 // Scroll 1 slide per swipe on mobile
        }
      }
    ]
  };
  
 
 
}
